import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import loading from './modules/loading'
import user from './modules/user'

import notifications from './modules/notification'
import progress from './modules/progress'
import young from './modules/register/young'
import youngSecondPart from './modules/register/youngSecondPart';
import system from './modules/system'
//import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        loading,
        user,
	    progress,
	    notifications,
	    young,
	    system,
	    youngSecondPart
    },
	plugins: [
		//createPersistedState()
	]
});
